import React from 'react'
import MainSlider from '../components/MainSlider';
import BestChoice from '../components/BestChoice';
import Contact_Info from '../components/Contact_Info'
import Services_Info from '../components/Services_Info';
import CoreTeam from '../components/CoreTeam .jsx'
import AboutInfo from '../components/AboutInfo.jsx';
import WelcomeSection from "../components/WelcomeSection";
import NewLaunch from '../components/NewLaunch.jsx';
import GapMaintainer from '../components/GapMaintainer.jsx';

function Home() {
  return (
    <div>
      <MainSlider/>
      {/* <GapMaintainer backroundColorNeeded={"#f9f9f9"} /> */}
      <WelcomeSection/>
      {/* <GapMaintainer backroundColorNeeded={"#f9f9f9"} /> */}
      <BestChoice/>
      <AboutInfo/>
      <Services_Info/>
      <GapMaintainer backroundColorNeeded={""} />
      <NewLaunch/>
      <GapMaintainer backroundColorNeeded={""} />
      <CoreTeam/>
      <Contact_Info/>
    </div>
  )
}

export default Home


